import { EventEmitter } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * Clipboard adapter which stores the clipboard content in a simple object
 * property. This adapter can be uased as a fallback ans should work in all
 * browsers
 *
 * @class ObjectAdapter
 * @extends EventEmitter
 */
export default class ObjectAdapter extends EventEmitter {
    /**
     * @type {Array}
     * @private
     */
    _storage = { context: null, items: [] };

    /**
     * Sets given items to the storage
     *
     * @param {string} context
     * @param {Object[]} items Array of item attribute objects
     */
    setItems(context, items) {
        this._storage = { context, items };
        this.trigger('change');
    }

    /**
     * Returns stored item attribute objects
     *
     * @param {string} context
     * @return {Object[]} Array of item attribute objects
     */
    getItems(context) {
        if (this._storage.context === context) return this._storage.items;

        return [];
    }

    /**
     * Returns if the storage contains items
     *
     * @param {string} context
     * @return {boolean}
     */
    hasItems(context) {
        return this.getItems(context).length > 0;
    }

    /**
     * Clears the storage
     */
    clear() {
        this._storage = { context: null, items: [] };
        this.trigger('change');
    }
}
